
export default [
    {
        path: "/events",
        name: "events",
        component: () => import(/* webpackChunkName: "events" */ "../views/events/EventsHome.vue"),
        meta: { requiresAuth: false }
    },
    {
        path: "/event/:id",
        name: "event_info",
        props: true,
        component: () => import(/* webpackChunkName: "event_info" */ "../views/events/EventRegistration.vue"),
        meta: { requiresAuth: false }
    },
    {
        path: "/event/:id/tickets",
        name: "view_event_tickets",
        props: true,
        component: () => import(/* webpackChunkName: "view_event_tickets" */ "../views/events/EventViewTickets.vue"),
        meta: { requiresAuth: false }
    },
]